import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetemployeeblogsmodal(BlogId) {
  return useQuery(['get-employee-blog-data-modal', BlogId], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.EMPLOYEE_BLOG_API, {
        id: BlogId,
      })
    );

    return response.data;
  });
}
